function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1284-566H636v2651h-1920z"
}), React.createElement("path", {
  d: "M-1285-259H635v2286h-1920z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  d: "M106.094 61.053c15.101 0 27.344 12.243 27.344 27.344 0 15.102-12.243 27.344-27.344 27.344-15.102 0-27.344-12.242-27.344-27.344 0-15.101 12.242-27.344 27.344-27.344zm0 2.188c-13.894 0-25.156 11.263-25.156 25.156 0 13.894 11.262 25.156 25.156 25.156 13.893 0 25.156-11.262 25.156-25.156 0-13.893-11.263-25.156-25.156-25.156zm-.67 11.09.053.044.791.966 2.534 3.001.835 1.007c.14.171.28.344.42.518l.84 1.06c2.64 3.403 5.04 7.222 5.04 10.574 0 3.068-1.218 5.84-3.204 7.858-1.986 2.019-4.714 3.257-7.733 3.257-3.02 0-5.747-1.265-7.733-3.257a11.155 11.155 0 0 1-3.205-7.858c0-3.176 2.154-6.77 4.626-10.033l.833-1.075c.14-.177.28-.352.421-.526l.84-1.026 2.95-3.5c.268-.321.516-.623.738-.902a.669.669 0 0 1 .954-.108zM105 77.232l-2.72 3.229-.588.72c-1.772 2.193-3.079 4.047-4.007 5.774-.952 1.77-1.435 3.298-1.435 4.546 0 2.411.933 4.655 2.566 6.314 1.659 1.663 3.857 2.613 6.184 2.613 2.349 0 4.538-.94 6.174-2.603a8.966 8.966 0 0 0 2.576-6.324c0-1.248-.483-2.776-1.435-4.546-.928-1.727-2.235-3.581-4.007-5.773l-.589-.721L105 77.232z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 16.92,
  y: 138.719
}, "Nawadnianie kropelkowe")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/drip.79abfbea.svg";
export { SvgComponent as ReactComponent };